import { Link } from "react-router-dom";

const CATEGORY_LINKS = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/news" },
  { label: "搜索", to: "/search" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-extrabold text-background-50">
                后
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                后入影视
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-600">
              后入影视网聚焦最新电影电视剧资源与影视资讯，为影视爱好者提供分类浏览、作品详情与实时资讯的一站式体验。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-600 transition-colors hover:bg-accent-500 hover:text-white">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-600 transition-colors hover:bg-accent-500 hover:text-white">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-secondary-600 transition-colors hover:bg-accent-500 hover:text-white">
                <i className="ri-mail-line"></i>
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-12">
            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                <Link to="/category/movie">影视分类</Link>
              </h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm text-secondary-600">
                {CATEGORY_LINKS.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="transition-colors hover:text-accent-600"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                热门题材
              </h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm text-secondary-600">
                <li>
                  <Link to="/category/movie" className="transition-colors hover:text-accent-600">
                    科幻冒险
                  </Link>
                </li>
                <li>
                  <Link to="/category/tv" className="transition-colors hover:text-accent-600">
                    悬疑犯罪
                  </Link>
                </li>
                <li>
                  <Link to="/category/tv" className="transition-colors hover:text-accent-600">
                    古装权谋
                  </Link>
                </li>
                <li>
                  <Link to="/category/movie" className="transition-colors hover:text-accent-600">
                    爱情剧情
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                关于本站
              </h4>
              <ul className="mt-4 flex flex-col gap-3 text-sm text-secondary-600">
                <li>本站为演示站点</li>
                <li>内容均为虚构示例</li>
                <li>不提供真实播放与下载</li>
                <li>仅供学习与展示用途</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-secondary-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 后入影视网 HOUJU MEDIA · 保留所有权利</p>
          <p>本网站为演示项目，所有影视内容与资讯均为虚构示例，不提供真实影音播放。</p>
        </div>
      </div>
    </footer>
  );
}